// check-crash-message — the PURE formatter behind the challenge Check panel's crash
// sentence (checker-diagnostics B2, Trello YyMk8kcZ). No DOM, no runner, no editor-core.
//
//   crashMessage(stderrText, noun) -> string | null
//
// Given everything a Check run wrote to stderr, it finds the LAST traceback's final
// exception line and the last STUDENT frame before it, and returns
//
//   "Your game crashed on line 12 of main.py: NameError: name 'scroe' is not defined."
//
// (`noun` is 'game' for pgzero/pygame, 'program' for console Python). A student frame is
// `File "<name>.py", line N` where the file is a bare name (the trimmed B1 format — e.g.
// `main.py`, `helper.py`) or a `/game/…` path (console Python and untrimmed fallbacks;
// displayed as its basename). A SyntaxError's `File "main.py", line N` block line counts
// the same way. A final "." is appended only when the exception line does not already end
// in ".", "?" or "!". Returns null when nothing parses — the caller then shows today's
// generic sentence.

var EXC_LINE = /^[A-Za-z_][\w.]*(Error|Exception|Warning|Exit|Interrupt|Iteration)(:.*)?$/;
var FRAME_LINE = /^\s*File "([^"]+)", line (\d+)/;
var TB_HEADER = /^Traceback \(most recent call last\):\s*$/;

function studentFile(name) {
  if (/^[^/\\<>]+\.py$/.test(name)) { return name; }
  var m = /^\/game\/(?:.*\/)?([^/]+\.py)$/.exec(name);
  return m ? m[1] : null;
}

export function crashMessage(stderrText, noun) {
  if (typeof stderrText !== 'string' || !stderrText) { return null; }
  var lines = stderrText.replace(/\r\n?/g, '\n').split('\n');

  // The LAST exception line wins (an earlier, handled traceback must not be named).
  var excIdx = -1;
  for (var i = lines.length - 1; i >= 0; i--) {
    if (EXC_LINE.test(lines[i].replace(/\s+$/, ''))) { excIdx = i; break; }
  }
  if (excIdx < 0) { return null; }
  var exc = lines[excIdx].replace(/\s+$/, '');

  // Walk back through THIS traceback only: stop at its header or a previous exception line.
  var file = null;
  var line = null;
  for (var j = excIdx - 1; j >= 0; j--) {
    var text = lines[j];
    if (TB_HEADER.test(text) || EXC_LINE.test(text.replace(/\s+$/, ''))) { break; }
    var f = FRAME_LINE.exec(text);
    if (!f) { continue; }
    var name = studentFile(f[1]);
    if (name) { file = name; line = f[2]; break; } // walking backwards: first hit = last frame
  }
  if (!file) { return null; }

  var end = /[.?!]$/.test(exc) ? '' : '.';
  return 'Your ' + (noun || 'game') + ' crashed on line ' + line + ' of ' + file + ': ' + exc + end;
}
